import { combineReducers } from 'redux';
import authReducer from './authReducer';
import employeeReducer from './employeeReducer';
import attendanceReducer from "./attendanceReducer";
import leaveReducer from "./leaveReducer";
import dashboardReducer from './dashboardReducer';  
import taskReducer from "./taskReducer";


const rootReducer = combineReducers({
  auth: authReducer,
  employee: employeeReducer,
  attendance: attendanceReducer,
  leave: leaveReducer,
  dashboard: dashboardReducer, 
  task: taskReducer,

});

export default rootReducer;
